import { render, staticRenderFns } from "./LiquidationDistributorLiquidated.vue?vue&type=template&id=a72e9218&"
import script from "./LiquidationDistributorLiquidated.vue?vue&type=script&lang=js&"
export * from "./LiquidationDistributorLiquidated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports